import React from 'react';
import { ArrowRight, Target } from 'lucide-react';
import type { CadeiaRecommendedAction } from '../../services/cadeiaChainInsights';
import { GRAVIDADE_STYLE } from '../../services/cadeiaSeverityStyles';

interface CadeiaRecommendedActionCardProps {
  action: CadeiaRecommendedAction;
  onOpenDiagnostic?: () => void;
}

/** Bloco executivo — ação recomendada prescriptiva. */
export const CadeiaRecommendedActionCard: React.FC<CadeiaRecommendedActionCardProps> = ({
  action,
  onOpenDiagnostic,
}) => {
  const isOk = action.gravidade === 'normal';
  const style = GRAVIDADE_STYLE[action.gravidade];

  return (
    <section className={`rounded-lg border px-3 py-2 ${style.border} ${isOk ? 'bg-emerald-50/50 dark:bg-emerald-950/15' : action.gravidade === 'critico' ? 'bg-red-50/60 dark:bg-red-950/20' : 'bg-amber-50/50 dark:bg-amber-950/15'}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="flex items-center gap-1 text-[9px] font-bold uppercase tracking-wide text-slate-500">
            <Target size={11} className="text-[#2F6FED]" />
            Ação Recomendada
          </p>
          <dl className="mt-1 space-y-1">
            <PrescRow label="O que fazer" value={action.whatToDo} bold />
            {!isOk && (
              <>
                <PrescRow label="Responsável" value={action.responsible} />
                <PrescRow label="Motivo" value={action.reason} />
                <PrescRow label="Prazo sugerido" value={action.suggestedDeadline} />
              </>
            )}
          </dl>
        </div>
        {!isOk && onOpenDiagnostic && (
          <button
            type="button"
            onClick={onOpenDiagnostic}
            className="inline-flex shrink-0 items-center gap-0.5 rounded border border-slate-200 bg-white px-2 py-1 text-[9px] font-semibold text-[#2F6FED] hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900"
          >
            Diagnóstico <ArrowRight size={10} />
          </button>
        )}
      </div>
    </section>
  );
};

function PrescRow({ label, value, bold }: { label: string; value: string; bold?: boolean }) {
  return (
    <div className="flex gap-2 text-[10px]">
      <dt className="w-[88px] shrink-0 font-semibold text-slate-500">{label}</dt>
      <dd className={`min-w-0 text-slate-700 dark:text-slate-300 ${bold ? 'font-bold text-slate-800 dark:text-slate-100' : ''}`}>
        {value}
      </dd>
    </div>
  );
}

export default CadeiaRecommendedActionCard;
